import { browser } from "./browser";
import { reactive } from "@odoo/owl";

/**
 * Reactive base osztály - biztosítja hogy az objektum reaktív legyen
 */
export class Reactive {
    constructor() {
        return reactive(this);
    }
}

/**
 * Egyszerűsített Router szolgáltatás
 * Kezeli az URL alapú navigációt és történetet
 */
export class SelfOrderRouter extends Reactive {
    constructor(...args) {
        super(...args);
        this.setup(...args);
    }

    setup() {
        this.path = window.location.pathname;
        this.registeredRoutes = {};
        this.historyPage = "";
        this.activeSlot = null;

        // URL változás figyelése
        window.addEventListener("popstate", () => {
            this.path = window.location.pathname;
        });
    }

    /**
     * Visszalépés az előző oldalra
     */
    back() {
        if (!this.historyPage.length) {
            this.navigate("default");
            return;
        }

        history.back();
        this.path = window.location.pathname;
        this.historyPage = window.location.pathname;
    }

    /**
     * Navigálás a megadott route-ra
     */
    navigate(routeName, routeParams = {}) {
        const { route } = this.registeredRoutes[routeName];
        const url = new URL(browser.location.href);

        url.pathname = route.replace(/\{\w+:(\w+)\}/g, (match, paramName) => {
            return routeParams[paramName];
        });

        history.pushState({}, "", url);
        this.path = window.location.pathname;
        this.historyPage = this.path;
    }

    /**
     * Route-ok regisztrálása
     */
    registerRoutes(routes) {
        Object.assign(this.registeredRoutes, routes);
    }
}

/**
 * Router service factory
 */
export const SelfOrderRouterService = {
    async start(env) {
        return new SelfOrderRouter(env);
    },
};

